import { Button, Label } from '@/components/ui'
import {
  type AccountDetails,
  NUMBER_MASK,
} from '@/modules/projects/components/Workbench/accounts'

const numberAt = (details: AccountDetails, index: number, typed: string) =>
  details.numbers.map((number, atIndex) => (atIndex === index ? typed : number))

export const NumbersField = ({
  details,
  onChange,
}: {
  details: AccountDetails
  onChange: (details: AccountDetails) => void
}) => (
  <div className="space-y-1.5">
    <Label htmlFor="add-account-number-0">Last four digits</Label>
    {details.numbers.map((number, index) => (
      <div
        // The inputs are positional, so they are keyed by position on purpose.
        // biome-ignore lint/suspicious/noArrayIndexKey: the row is the position
        key={index}
        className="flex items-center gap-2"
      >
        <div className="flex h-9 w-36 items-center gap-1 rounded-md border border-input px-3 shadow-sm focus-within:ring-1 focus-within:ring-ring">
          <span className="text-neutral-400">{NUMBER_MASK}</span>
          <input
            id={`add-account-number-${index}`}
            data-account-number-input={index}
            value={number}
            onChange={(event) =>
              onChange({
                ...details,
                numbers: numberAt(details, index, event.target.value),
              })
            }
            placeholder="0000"
            className="w-full bg-transparent text-sm tabular-nums outline-none placeholder:text-muted-foreground"
          />
        </div>
        {details.numbers.length > 1 ? (
          <Button
            size="xs"
            theme="ghost"
            onClick={() =>
              onChange({
                ...details,
                numbers: details.numbers.filter(
                  (_unused, atIndex) => atIndex !== index,
                ),
              })
            }
          >
            Drop
          </Button>
        ) : null}
      </div>
    ))}
    <button
      type="button"
      onClick={() =>
        onChange({ ...details, numbers: [...details.numbers, ''] })
      }
      className="cursor-pointer text-xs text-blue-700 hover:underline"
    >
      + Another number on the same mailing
    </button>
    <p className="text-xs text-ink-subtle">
      The bank prints only the last four. A misread digit can be corrected on
      the map later.
    </p>
  </div>
)
